import dayjs, { ConfigType, Dayjs } from 'dayjs'

import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY'
export const DAYJS_DATE_FORMAT = 'YYYY-MM-DD'

export const formatDate = (date: ConfigType, format = DEFAULT_DATE_FORMAT): string =>
  date ? dayjs.utc(date)?.format(format) : null

export const formatDateIntoDayJs = (date: ConfigType, format = DEFAULT_DATE_FORMAT): string =>
  date ? dayjs.utc(date, format)?.format(DAYJS_DATE_FORMAT) : null

export const formatDateIntoUTC = (date: ConfigType, format?: string): string =>
  date ? dayjs.utc(date, format)?.format() : null

export class DateRange {
  startDate: Dayjs
  endDate: Dayjs
}
